/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PremiumDueBinderOptionDto
 */
export interface PremiumDueBinderOptionDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumDueBinderOptionDto
     */
    binderId: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueBinderOptionDto
     */
    name: string;
}

/**
 * Check if a given object implements the PremiumDueBinderOptionDto interface.
 */
export function instanceOfPremiumDueBinderOptionDto(value: object): value is PremiumDueBinderOptionDto {
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PremiumDueBinderOptionDtoFromJSON(json: any): PremiumDueBinderOptionDto {
    return PremiumDueBinderOptionDtoFromJSONTyped(json, false);
}

export function PremiumDueBinderOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumDueBinderOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'binderId': json['binderId'],
        'name': json['name'],
    };
}

export function PremiumDueBinderOptionDtoToJSON(json: any): PremiumDueBinderOptionDto {
    return PremiumDueBinderOptionDtoToJSONTyped(json, false);
}

export function PremiumDueBinderOptionDtoToJSONTyped(value?: PremiumDueBinderOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'binderId': value['binderId'],
        'name': value['name'],
    };
}

